
import { z } from "zod";

export const PvSystemOverridePriceTypeValues = ["Panel", "System"] as const;
export const PvSystemOverridePriceTypeSchema = /* @__PURE__ */ z.enum(PvSystemOverridePriceTypeValues);
export const PvSystemOverridePriceType: (typeof PvSystemOverridePriceTypeSchema)["enum"] = { "Panel": "Panel", "System": "System" };
export type PvSystemOverridePriceType = (typeof PvSystemOverridePriceTypeValues)[number];
